import { render, staticRenderFns } from "./expectedReport.vue?vue&type=template&id=563bfe42"
import script from "./expectedReport.vue?vue&type=script&lang=js"
export * from "./expectedReport.vue?vue&type=script&lang=js"
import style0 from "./expectedReport.vue?vue&type=style&index=0&id=563bfe42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports